import { faCheck } from '@awesome.me/kit-5452b20ec3/icons/classic/solid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import styles from './Navigation.module.scss'

type Step = {
  path: string
  label: string
}

type NavigationProps = {
  activeIndex: number
  steps: Step[]
}

function getStatus(index: number, activeIndex: number): 'completed' | 'current' | 'next' {
  if (index < activeIndex) return 'completed'
  if (index === activeIndex) return 'current'
  return 'next'
}

const Navigation: React.FC<NavigationProps> = ({ activeIndex, steps }) => (
  <ul className={styles.navigation}>
    {steps.map((step, index) => {
      const status = getStatus(index, activeIndex)
      const isLast = index === steps.length - 1
      return (
        <li
          key={index}
          className={`${styles.step} ${styles[status]}`}
          aria-current={status === 'current' ? 'step' : undefined}
        >
          <div className={styles.stepContent}>
            <div className={styles.stepCircle}>
              {status === 'completed' ? (
                <FontAwesomeIcon className={styles.icon} icon={faCheck} />
              ) : (
                <span className={styles.stepNumber}>{(index + 1).toString().padStart(2, '0')}</span>
              )}
            </div>
            <div className={styles.stepLabel}>{step.label}</div>
          </div>
          {!isLast && <div className={`${styles.connector} ${styles[status]}`} aria-hidden="true" />}
        </li>
      )
    })}
  </ul>
)

export default Navigation
